import {Component, Inject, OnInit, Renderer2,ElementRef, PLATFORM_ID} from '@angular/core';
import {ApiServices} from '../../shared/services/api.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {HelperService} from '../../shared/services/helper.service';
import {ToastrService} from 'ngx-toastr';
// import { saveAs } from 'file-saver';

import {environment} from '../../../environments/environment';
// import { HttpClient, HttpHeaders } from '@angular/common/http';



@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {

  vendorDownloadList:any = [];

  constructor(
    private apiService: ApiServices,
    private router: Router,
    private route: ActivatedRoute,
    private helperService: HelperService,
    private toastr: ToastrService,
    private _renderer2: Renderer2, 
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {

    helperService.setPageTitle(route.snapshot.data.title);
  }

  ngOnInit(): void {
    this.checkIfLoggedIn();
    this.getDownloadListing();
  }

  onSearchVendor($event): void {
    if ($event.target.value) {
      this.getDownloadListing($event.target.value);
    }
  }

  clearSearch():void {
    this.getDownloadListing(null);
  }

  getDownloadListing(query=null){
    this.vendorDownloadList = null;
    this.apiService.vendorsDownloadListing(query).subscribe(response => {
      if (response.status) {
        this.vendorDownloadList = response.data.vendors;
        // console.log(this.delerVendors);
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  checkIfLoggedIn() {
    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
    } else {
      this.toastr.error("Please login first", 'Error');
      this.router.navigateByUrl('/');
    }
  }

  downloadCSVFile(vendorId){

    const url =  environment.apiPath + 'vendor-data/'+vendorId;
    window.location.href = url;
    /*let date: Date = new Date();
    // var file = new File(["Hello, world!"], "hello world.txt", {type: "text/plain;charset=utf-8"});
    // saveAs(file);

    this.apiService.vendorFileDownload(vendorId)
    .subscribe(response => {
      const data: Blob = new Blob([response], {
        type: "text/csv;charset=utf-8"
      });

      saveAs(data, "products.csv");
    }, error => {
      // console.log([error])
      this.toastr.error(error.error.message, 'Error');
    });*/
  }

  ngAfterViewInit() {
    // Add a class to the body element
    this.renderer.addClass(document.body, 'grey-account-bg');
  }
  ngOnDestroy() {
    // Remove the class from the body element
    this.renderer.removeClass(document.body, 'grey-account-bg');
  }

}
